<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!blackListUser">
      <span class="loader"></span>
    </span>
    <black-list-user-form
      v-if="blackListUser"
      :loading="loading"
      :blackListUserData="blackListUser"
      :formErrors="formErrors"
      @blackListUserSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import BlackListUserForm from "../partials/BlackListUserForm.vue";

export default {
  layout: "DashboardLayout",

  components: { BlackListUserForm },

  mixins: [alertLeave],

  props: {
    blackListUserId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      blackListUser: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("blackListUsers/get", this.blackListUserId);
        this.blackListUser = this.$store.getters["blackListUsers/blackListUser"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(blackListUser) {
      this.loading = true;
      let blackListUserData = cloneDeep(blackListUser);
      blackListUserData.relationshipNames = ["user","organization"];

      try {
        await this.$store.dispatch("blackListUsers/update", blackListUserData);
        this.$notify({
          type: "success",
          message: this.$t("BLACK_LIST_USERS.BLACK_LIST_USER_UPDATED"),
        });
        const blackListUser = this.$store.getters["blackListUsers/blackListUser"];
        this.$emit("onViewBlackListUser", blackListUser, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
